<template>
    <div class="progress_description_container"
        :style="progressStyle"
    >
        <p class="progress_description_description" >
            <span class="left_description">
                <slot name="leftDescription"></slot>
                {{ leftDescription }}
                <Tip v-if="tip">{{ tip }}</Tip>
            </span>
            <span class="right_description">
                <slot name="rightDescription"></slot>
                <span class="right_description_current" >{{ calcFinalDataStr(current) }}</span>
                <span class="right_description_all" >/{{ totalDataSize }}</span>
            </span>
        </p>
        <div class="progress_container">
            <ElProgress :percentage="percentage"
                :show-text="false"
                :color="detailItems[0]?.color"
                define-back-color="var(--fill_primary)"/>
        </div>
        <div class="details">
            <div class="detail" v-for="detail in detailItems" :key="detail.text">
                <div>
                    <div class="color" :style="{backgroundColor: detail.color}"></div>
                    <div class="text">
                        {{ detail.text }}
                    </div>
                    <Tip v-if="detail.tip">{{ detail.tip }}</Tip>
                </div>
                <div>
                    <div class="current">{{ detail.current }}</div>
                    <div class="total">/{{detail.isUnlimited?$t('plan.unlimited'): detail.total }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { CSSProperties, PropType } from 'vue';
import Tip from '@/basic/Tip.vue';
import { Progress as ElProgress } from 'element-ui';
import { calcFinalDataStrNormal as calcFinalDataStr } from '@/common/js/utils';
export interface IRawDetailItem {
    text: string;
    tip?: string;
    color: string;
    current: number;
    total: number;
    isUnlimited: boolean;
}

interface IDetailItem {
    text: string;
    tip?: string;
    color: string;
    current: string;
    total: string;
    isUnlimited: boolean;
}

export default Vue.extend({
    props: {
        leftDescription: {
            type: String,
            required: false
        },
        tip: {
            type: String,
            required: false
        },
        items: Array as PropType<IRawDetailItem[]>,
        unlimitedInfo: {
            type: Object as PropType<{ hasUnlimitedAddOn: boolean; isUnlimitedMain: boolean; }>,
            required: false,
            default: () => ({ hasUnlimitedAddOn: false, isUnlimitedMain: false })
        }
    },
    components: {
        ElProgress,
        Tip
    },
    computed: {
        detailItems(): IDetailItem[] {

            return this.items.map( item => {

                return {
                    ...item,
                    current: calcFinalDataStr( item.current ),
                    total: calcFinalDataStr( item.total )
                } ;

            });

        },

        current(): number {

            return this.items.reduce(( sum, current ) => sum + current.current, 0 );

        },

        all(): number {

            return this.items.reduce(( sum, current ) => sum + current.total, 0 );

        },

        totalDataSize(): string {

            return this.items.some( item => item.isUnlimited ) ?
                this.$t( 'plan.unlimited' ).toString() :
                calcFinalDataStr( this.all );

        },

        percentage(): number {

            if ( this.all === 0 ) {

                return 0;

            }
            return this.current / this.all * 100;

        },

        progressStyle(): CSSProperties {

            return {
                '--percentage-2': this.tempSecondPercentage,
                '--percentage-2-color': this.detailItems[1].color
            };

        },

        /**
         * 目前此组件仅实现了两个颜色的混合，如果需要服用此组件且需要两种以上颜色在进度条上混合，请自行实现
         */
        tempSecondPercentage(): string {

            if ( this.current === 0 ) {

                return '0%';

            }

            return `${( this.items[1].current / this.current * 100 )}%`;

        }
    },
    methods: {
        calcFinalDataStr,
    }
});
</script>

<style lang="less" scoped>
.progress_description_container {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .progress_description_description {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 600;

        .left_description {
            color: @font_primary;
        }

        .right_description {
            .right_description_all {
                color: @font_secondary
            }

            .right_description_current {
                color: @b_6;
            }
        }
    }

    .progress_container {
        padding: 24px 0;
        border-bottom: 1px solid @line;
        @media @mobile{
            padding-top: 8px;
        }
    }

    .details{
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding-top: 24px;
        .detail{
            display: flex;
            align-items: center;
            justify-content: space-between;
            & > div{
                display: flex;
                align-items: center;
            }
            .color{
                width: 14px;
                height: 14px;
                border-radius: 2px;
                flex-shrink: 0;
            }
            .text{
                font-size: 14px;
                font-weight: 500;
                color: @font_secondary;
                margin-left: 12px;
                margin-right: 4px;
            }
            .total{
                font-size: 14px;
                font-weight: 500;
                color: @font_secondary;
            }
            .current{
                font-size: 14px;
                font-weight: 500;
                color: @b_6;
            }
        }
    }
}
</style>

<style lang="less">
.el-progress-bar__inner::after{
    width: var(--percentage-2);
    height: 100%;
    background-color: var(--percentage-2-color);
    position: absolute;
    top: 0;
    right: 0;
}
</style>
